import {IntlShape} from "react-intl";
import {formatDay} from "./dateFormat";

export function formatServicePeriod(intl: IntlShape, start: string | null | undefined, end: string | null | undefined): string | null {
    if (!start || !end) {
        return null;
    }
    return formatDay(intl, start) + ' – ' + formatDay(intl, end);
}

/**
 * The month of the invoice date, e.g. "Okt. 2025". An invoice without service period counts in
 * this month.
 */
export function formatInvoiceMonth(intl: IntlShape, invoiceDate: string): string {
    return intl.formatDate(new Date(invoiceDate.slice(0, 7) + '-01T00:00:00Z'), {month: 'short', year: 'numeric', timeZone: 'UTC'});
}

/**
 * Formats cents of the given currency, e.g. the original amount of an invoice in USD.
 */
export function formatAmountInCurrency(intl: IntlShape, cents: number, currency: string): string {
    return intl.formatNumber(cents / 100, {style: 'currency', currency});
}
